<template>
  <div class="note">
    <div class="message">
      {{ note.note }}
    </div>
    <div class="bottom">
      <div class="user">
        <div class="initials">
          {{ getUserInitials(note.user.name) }}
        </div>
        <div class="details">
          <div class="name">{{ note.user.name }}</div>
          <div class="date">{{ getPrettyDate(note.createdAt) }} - {{ getPrettyTime(note.createdAt) }}</div>
        </div>
      </div>
      <div class="remove">
        <button class="btn" v-on:click="removeNote">
          <span class="spinner-border spinner-border-sm" role="status" v-if="isRemoving"></span>
          <span v-if="isRemoving">Removing...</span>
          <span v-else>Remove note</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: 'WaitlistNoteSingle',
  data: function () {
    return {
      isRemoving: false,
    };
  },
  props: ['note', 'removedNote'],
  methods: {
    getUserInitials: function (name) {
      let capitals = name.matchAll(/[A-Z]/g);
      return Array.from(capitals, x => x[0]).join("");
    },
    getPrettyDate: function (noteDate) {
      let date = new Date(noteDate);
      return date.toLocaleString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
    },
    getPrettyTime: function (noteDate) {
      let date = new Date(noteDate);
      return date.toLocaleString('en-US', { hour: 'numeric', minute: '2-digit', dayPeriod: 'short' });
    },
    removeNote: function () {
      this.isRemoving = true;
      axios.get(`/api/waitlist/notes/${this.note.id}/delete`, {})
        .then(() => {
          this.removedNote(this.note.id);
        })
        .finally(() => {
          this.isRemoving = false;
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/_variables";

div.note {
  padding: 63px 57px 50px;
  border-bottom: 1px solid rgba(#222222, 0.14);

  &:last-child {
    border-bottom: none;
  }

  div.message {
    font-size: 0.875rem;
    color: #4A4A4A;
    line-height: calc(20/14);
    margin: 0 0 30px;
  }

  div.bottom {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: flex-end;

    div.user {
      display: flex;

      div.initials {
        width: 45px;
        height: 45px;
        color: white;
      }

      div.details {
        div.name {
          font-size: 1rem;
          color: #4A4A4A;
          line-height: calc(18/16);
          margin: 0 0 7px;
        }

        div.date {
          font-size: 0.75rem;
          color: #848484;
          line-height: calc(20/12);
        }
      }
    }

    div.remove {
      button.btn {
        color: var(--accentColor);
        font-size: 0.7rem;
        line-height: calc(13/11.2);
        padding: 0;

        &:hover {
          color: var(--accentColorExtraDark);
        }

        .spinner-border-sm {
          width: 0.75rem;
          height: 0.75rem;
          margin-right: 0.5em;
        }
      }
    }
  }
}
</style>
